module.exports = __webpack_public_path__ + "static/media/1000953.6d3415b3.png";